/**
 * DRI Insights constants.
 * Chart dimensions, BU abbreviations, and month labels for DRI/certification views.
 */

/** Chart height for DRI bar/line charts (consistent across views). */
export const DRI_CHART_HEIGHT = 500;

/** Line chart height (larger than bar chart). */
export const DRI_LINE_CHART_HEIGHT = 600;

/** Business Unit display name -> abbreviation map. */
export const BU_ABBREVIATION_MAP: Record<string, string> = {
  'Delivery | Cloud Engineering': 'CE',
  'Delivery | Data Engineering': 'DE',
  'Delivery | Cloud Security & Reliability Engineering': 'CSRE',
  'Delivery | Decision Intelligence Engineering': 'DIE',
  'Delivery | Modern Product Engineering': 'MPE',
  'Delivery | Modern Work Ops Engineering': 'MWOE',
  'Delivery | AI Engineering': 'AIE',
  'Client Success': 'CS',
  'Client Innovation & Capabilities': 'CIC',
};

/** Full month names (1-based index). */
export const MONTH_NAMES = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
];

/** Short month labels (e.g. for charts). */
export const MONTH_ABBREVIATIONS = [
  'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
];
